import * as z from "zod";

/**
 * Schema for variant/control group revenue statistics
 */
const groupRevenueStatsSchema_ = z.object({
  /** Revenue per customer in the group's currency */
  revenuePerCustomer: z.number(),
  /** Total attributed revenue for this group */
  totalRevenue: z.number(),
  /** Revenue per 1,000 customers (totalRevenue / customerCount * 1000) */
  revenuePer1kCustomers: z.number(),
  /** Total customers in this group */
  customerCount: z.number(),
});
export const groupRevenueStatsSchema: z.ZodType<GroupRevenueStats> =
  groupRevenueStatsSchema_;
export interface GroupRevenueStats
  extends z.infer<typeof groupRevenueStatsSchema_> {}

const revenueStatsOutputSchema_ = z.object({
  /** Marketing agent (variant) group stats */
  variant: groupRevenueStatsSchema,
  /** Legacy automations (control) group stats */
  control: groupRevenueStatsSchema,
});
export const revenueStatsOutputSchema: z.ZodType<RevenueStatsOutput> =
  revenueStatsOutputSchema_;
export interface RevenueStatsOutput
  extends z.infer<typeof revenueStatsOutputSchema_> {}

export const getMarketingAgentRevenueStats = {
  name: "getMarketingAgentRevenueStats" as const,
  input: z.object({
    /** Max number of days to look back */
    days: z.number(),
    splitId: z.string().optional(),
  }),
  output: revenueStatsOutputSchema.nullable(),
};
